import { styled } from '@linaria/react';
import { colors, fonts, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  width: 100%;
  z-index: 1;

  &[data-open='true'] {
    z-index: 100;
  }
`;

export const Trigger = styled.button<{ $variant?: 'default' | 'pill' }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space[2]};
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  padding: ${(p) => (p.$variant === 'pill' ? '8px 16px' : '10px 12px')};
  border: ${(p) => (p.$variant === 'pill' ? 'none' : `1px solid ${colors.borderGrey}`)};
  border-radius: ${(p) => (p.$variant === 'pill' ? '100px' : '8px')};
  background: ${(p) => (p.$variant === 'pill' ? colors.lighterGrey : colors.white)};
  color: ${colors.fontPrimary};
  cursor: pointer;
  outline: none;
  min-width: 100px;
  width: 100%;
  text-align: left;
  transition: border-color 0.15s ease, background 0.15s ease;

  &:focus {
    border-color: ${(p) => (p.$variant === 'pill' ? 'transparent' : colors.primary)};
    background: ${(p) => (p.$variant === 'pill' ? colors.borderGrey : colors.white)};
  }

  &[data-open='true'] {
    border-color: ${(p) => (p.$variant === 'pill' ? 'transparent' : colors.primary)};
    background: ${(p) => (p.$variant === 'pill' ? colors.borderGrey : colors.white)};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const TriggerText = styled.span`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Placeholder = styled.span`
  color: ${colors.grey};
`;

export const Chevron = styled.span<{ $open: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.15s ease;
  transform: ${(p) => (p.$open ? 'rotate(180deg)' : 'rotate(0deg)')};
  color: ${colors.fontSecondary};
`;

export const OptionsList = styled.ul`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  z-index: 200;
  margin: 0;
  padding: ${space[1]} 0;
  list-style: none;
  background: ${colors.white};
  border: 1px solid ${colors.borderGrey};
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  max-height: 240px;
  white-space: nowrap;
  min-width: 100%;
  display: flex;
  flex-direction: column;

  &[data-align='left'] {
    right: auto;
    left: 0;
  }
`;

export const SearchInput = styled.input`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  padding: ${space[3]};
  border: none;
  border-bottom: 1px solid ${colors.borderGrey};
  outline: none;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;

  &::placeholder {
    color: ${colors.grey};
  }
`;

export const OptionsContainer = styled.div`
  overflow-y: auto;
  flex: 1;
`;

export const Option = styled.li`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  padding: 8px 12px;
  cursor: pointer;
  color: ${colors.fontPrimary};
  transition: background 0.1s ease;

  &:hover,
  &[data-active='true'] {
    background: ${colors.lighterGrey};
  }

  &[data-selected='true'] {
    font-weight: ${fonts.weight.semiBold};
  }

  &[data-disabled='true'] {
    opacity: 0.4;
    cursor: not-allowed;
    pointer-events: none;
  }
`;
